import { BiDraftDetail } from '@euler/model/bi/draft';
import {
  BiDatasetDetail,
  BiDatasetList,
  BiDatasetPreview,
  BiDatasetSharingResult,
} from '@euler/model/bi/library';
import { BiUploadView } from '@euler/model/bi/upload';

/*
 * Real responses of the running dev rear (store 323), captured on
 * 2026-10-17 over the BiService hop euler uses, from uploads and datasets
 * fabricated for the capture and deleted after: a workbook split into four
 * sheet uploads (ready with proposals, waiting for confirmation, failed),
 * the same file again (a duplicate waiting for a sheet choice), a file that
 * could not be read, a private dataset used on one dashboard and a
 * colleague's dataset shared with the store. Enum values stay as the wire
 * sends them.
 */

export const kCapturedSplitUpload = {
  id: 'biupl_01m53sz6qhsaqrjw2nthakrw1t',
  fileName: '2025配件采购.xlsx',
  status: 'split',
  intent: '这是我们 2025 年的配件采购',
  rowLimit: 50000,
  duplicates: [],
  sheets: [
    {
      name: '配件采购',
      rowCount: 186,
      columnCount: 6,
      headers: ['采购日期', '供应商', '配件名称', '数量', '金额(元)', '车牌号'],
      block: null,
      alreadyImported: false,
      upload: {
        id: 'biupl_01m53sz6qj017bp230ea90x5p2',
        sheet: '配件采购',
        status: 'ready',
        generation: 2,
        schema: {
          description:
            '2025 年配件采购明细：每行是一次采购，含日期、供应商、配件、数量和金额。',
          primaryTime: 'f_purchase_date',
          columns: [
            {
              key: 'f_purchase_date',
              label: '采购日期',
              sourceHeader: '采购日期',
              type: 'date',
              role: 'time',
              conformedKey: 'date',
            },
            {
              key: 'f_supplier',
              label: '供应商',
              sourceHeader: '供应商',
              type: 'string',
              role: 'dimension',
            },
            {
              key: 'f_part_name',
              label: '配件名称',
              sourceHeader: '配件名称',
              type: 'string',
              role: 'dimension',
            },
            {
              key: 'f_quantity',
              label: '数量',
              sourceHeader: '数量',
              type: 'number',
              role: 'measure',
              defaultAgg: 'sum',
            },
            {
              key: 'f_amount',
              label: '金额',
              sourceHeader: '金额(元)',
              type: 'number',
              role: 'measure',
              defaultAgg: 'sum',
              format: { kind: 'currency' },
            },
            {
              key: 'f_license_plate',
              label: '车牌',
              sourceHeader: '车牌号',
              type: 'string',
              role: 'dimension',
              conformedKey: 'license_plate',
            },
          ],
        },
        datasetId: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
        proposalDraftIds: [
          'bidraft_01m53sz78hc5sfy0mhd3jma1pq',
          'bidraft_01m53sz796wggrt9v5342ntxr3',
          'bidraft_01m53sz79r5t8s01aaj7kashvk',
          'bidraft_01m53sz7aaqteyft88n2wxb68z',
        ],
        failure: null,
      },
    },
    {
      name: '供应商',
      rowCount: 23,
      columnCount: 5,
      headers: ['供应商名称', '联系人', '所在城市', '合作起始年', '联系电话'],
      block: null,
      alreadyImported: false,
      upload: {
        id: 'biupl_01m53sz77ddzzkehcaj3ghtp7n',
        sheet: '供应商',
        status: 'needs_confirmation',
        generation: 1,
        schema: {
          description: '供应商名录：每行一个供应商，含联系人、城市和合作年份。',
          columns: [
            {
              key: 'f_supplier',
              label: '供应商',
              sourceHeader: '供应商名称',
              type: 'string',
              role: 'dimension',
            },
            {
              key: 'f_contact',
              label: '联系人',
              sourceHeader: '联系人',
              type: 'string',
              role: 'dimension',
            },
            {
              key: 'f_city',
              label: '城市',
              sourceHeader: '所在城市',
              type: 'string',
              role: 'dimension',
            },
            {
              key: 'f_since',
              label: '合作年份',
              sourceHeader: '合作起始年',
              type: 'number',
              role: 'measure',
              defaultAgg: 'sum',
            },
            {
              key: 'f_phone',
              label: '电话',
              sourceHeader: '联系电话',
              type: 'string',
              role: 'dimension',
            },
          ],
        },
        datasetId: null,
        proposalDraftIds: [],
        failure: null,
      },
    },
    {
      name: '退货',
      rowCount: 12,
      columnCount: 3,
      headers: ['日期', '配件', '原因'],
      block: null,
      alreadyImported: false,
      upload: {
        id: 'biupl_01m53sz77e2vec89e77bphd7fk',
        sheet: '退货',
        status: 'failed',
        generation: 1,
        schema: null,
        datasetId: null,
        proposalDraftIds: [],
        failure: 'interpret',
      },
    },
    {
      name: '全年明细',
      rowCount: 61234,
      columnCount: 3,
      headers: ['日期', '单号', '金额'],
      block: 'row_limit',
      alreadyImported: false,
      upload: null,
    },
    {
      name: '说明',
      rowCount: 0,
      columnCount: 1,
      headers: ['备注'],
      block: 'empty',
      alreadyImported: false,
      upload: null,
    },
  ],
  failure: null,
  createdAt: '2026-10-17T02:10:04.000Z',
  updatedAt: '2026-10-17T02:10:04.000Z',
} as unknown as BiUploadView;

export const kCapturedDuplicateUpload = {
  id: 'biupl_01m53sz7adsjravnqeaz7tx96f',
  fileName: '2025配件采购.xlsx',
  status: 'needs_sheet_selection',
  intent: null,
  rowLimit: 50000,
  duplicates: [
    {
      datasetId: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
      name: '2025 配件采购',
      sheet: '配件采购',
      createdAt: '2026-10-17T02:10:05.000Z',
    },
  ],
  sheets: [
    {
      name: '配件采购',
      rowCount: 186,
      columnCount: 6,
      headers: ['采购日期', '供应商', '配件名称', '数量', '金额(元)', '车牌号'],
      block: null,
      alreadyImported: true,
      upload: null,
    },
    {
      name: '供应商',
      rowCount: 23,
      columnCount: 5,
      headers: ['供应商名称', '联系人', '所在城市', '合作起始年', '联系电话'],
      block: null,
      alreadyImported: false,
      upload: null,
    },
    {
      name: '退货',
      rowCount: 12,
      columnCount: 3,
      headers: ['日期', '配件', '原因'],
      block: null,
      alreadyImported: false,
      upload: null,
    },
    {
      name: '全年明细',
      rowCount: 61234,
      columnCount: 3,
      headers: ['日期', '单号', '金额'],
      block: 'row_limit',
      alreadyImported: false,
      upload: null,
    },
    {
      name: '说明',
      rowCount: 0,
      columnCount: 1,
      headers: ['备注'],
      block: 'empty',
      alreadyImported: false,
      upload: null,
    },
  ],
  failure: null,
  createdAt: '2026-10-17T02:10:05.000Z',
  updatedAt: '2026-10-17T02:10:05.000Z',
} as unknown as BiUploadView;

export const kCapturedFailedUpload = {
  id: 'biupl_01m53sz7ae7wcnrhttbcqnywsk',
  fileName: '门店月报-损坏.xlsx',
  status: 'failed',
  intent: null,
  rowLimit: null,
  duplicates: [],
  sheets: [],
  failure: 'file',
  createdAt: '2026-10-17T02:10:05.000Z',
  updatedAt: '2026-10-17T02:10:05.000Z',
} as unknown as BiUploadView;

/** The ready sheet's proposals. */
export const kCapturedProposals = [
  {
    id: 'bidraft_01m53sz78hc5sfy0mhd3jma1pq',
    title: '每月采购金额',
    spec: {
      dataset: {
        kind: 'upload',
        datasetId: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
      },
      measures: [
        {
          kind: 'field',
          field: 'f_amount',
        },
      ],
      dimensions: [
        {
          field: 'f_purchase_date',
          grain: 'month',
        },
      ],
      filters: [],
      sort: [],
    },
    viz: {
      type: 'line',
      x: 'f_purchase_date__month',
      series: [
        {
          key: 'f_amount',
        },
      ],
    },
    result: {
      current: {
        columns: [
          {
            key: 'f_purchase_date__month',
            label: {
              zh: '采购日期（月）',
              en: '采购日期 (month)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'f_amount',
            label: {
              zh: '金额',
              en: '金额',
            },
            type: 'number',
            role: 'measure',
          },
        ],
        rows: [
          ['2025-01', 10460],
          ['2025-02', 8352],
          ['2025-03', 6244],
          ['2025-04', 5936],
          ['2025-05', 6528],
          ['2025-06', 7120],
          ['2025-07', 7050],
          ['2025-08', 7605],
          ['2025-09', 8160],
          ['2025-10', 8715],
          ['2025-11', 9270],
          ['2025-12', 9825],
        ],
        truncated: false,
        asOf: '2026-10-17T02:10:05.172Z',
      },
    },
    parentDraftId: null,
    rationale: '看全年采购花费的走势，找出采购高峰月份。',
    createdAt: '2026-10-17T02:10:05.000Z',
    expiresAt: '2026-11-16T02:10:05.000Z',
    addedTo: [],
  },
  {
    id: 'bidraft_01m53sz796wggrt9v5342ntxr3',
    title: '各供应商采购金额',
    spec: {
      dataset: {
        kind: 'upload',
        datasetId: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
      },
      measures: [
        {
          kind: 'field',
          field: 'f_amount',
        },
      ],
      dimensions: [
        {
          field: 'f_supplier',
        },
      ],
      filters: [],
      sort: [
        {
          key: 'f_amount',
          dir: 'desc',
        },
      ],
    },
    viz: {
      type: 'bar',
      x: 'f_supplier',
      series: [
        {
          key: 'f_amount',
        },
      ],
    },
    result: {
      current: {
        columns: [
          {
            key: 'f_supplier',
            label: {
              zh: '供应商',
              en: '供应商',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'f_amount',
            label: {
              zh: '金额',
              en: '金额',
            },
            type: 'number',
            role: 'measure',
          },
        ],
        rows: [
          ['博世配件', 19695],
          ['法雷奥', 19146],
          ['嘉实多', 19108],
          ['曼牌滤清器', 18677],
          ['马牌轮胎', 18639],
        ],
        truncated: false,
        asOf: '2026-10-17T02:10:05.209Z',
      },
    },
    parentDraftId: null,
    rationale: '比较各供应商的采购占比，便于议价。',
    createdAt: '2026-10-17T02:10:05.000Z',
    expiresAt: '2026-11-16T02:10:05.000Z',
    addedTo: [],
  },
  {
    id: 'bidraft_01m53sz79r5t8s01aaj7kashvk',
    title: '配件采购数量占比',
    spec: {
      dataset: {
        kind: 'upload',
        datasetId: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
      },
      measures: [
        {
          kind: 'field',
          field: 'f_quantity',
        },
      ],
      dimensions: [
        {
          field: 'f_part_name',
        },
      ],
      filters: [],
      sort: [
        {
          key: 'f_quantity',
          dir: 'desc',
        },
      ],
    },
    viz: {
      type: 'pie',
      x: 'f_part_name',
      series: [
        {
          key: 'f_quantity',
        },
      ],
    },
    result: {
      current: {
        columns: [
          {
            key: 'f_part_name',
            label: {
              zh: '配件名称',
              en: '配件名称',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'f_quantity',
            label: {
              zh: '数量',
              en: '数量',
            },
            type: 'number',
            role: 'measure',
          },
        ],
        rows: [
          ['雨刮', 186],
          ['轮胎', 183],
          ['火花塞', 155],
          ['刹车片', 152],
          ['机油', 124],
          ['机油滤芯', 121],
        ],
        truncated: false,
        asOf: '2026-10-17T02:10:05.227Z',
      },
    },
    parentDraftId: null,
    rationale: '哪些配件用得最多，决定备货重点。',
    createdAt: '2026-10-17T02:10:05.000Z',
    expiresAt: '2026-11-16T02:10:05.000Z',
    addedTo: [],
  },
  {
    id: 'bidraft_01m53sz7aaqteyft88n2wxb68z',
    title: '全年采购总额',
    spec: {
      dataset: {
        kind: 'upload',
        datasetId: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
      },
      measures: [
        {
          kind: 'field',
          field: 'f_amount',
        },
      ],
      dimensions: [],
      filters: [],
      sort: [],
    },
    viz: {
      type: 'kpi',
      value: 'f_amount',
    },
    result: {
      current: {
        columns: [
          {
            key: 'f_amount',
            label: {
              zh: '金额',
              en: '金额',
            },
            type: 'number',
            role: 'measure',
          },
        ],
        rows: [[95265]],
        truncated: false,
        asOf: '2026-10-17T02:10:05.246Z',
      },
    },
    parentDraftId: null,
    rationale: '一眼看到全年的采购规模。',
    createdAt: '2026-10-17T02:10:05.000Z',
    expiresAt: '2026-11-16T02:10:05.000Z',
    addedTo: [],
  },
] as unknown as BiDraftDetail[];

export const kCapturedMine = {
  section: 'mine',
  datasets: [
    {
      kind: 'upload',
      dataset: {
        id: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
        name: '2025 配件采购',
        description:
          '2025 年配件采购明细：每行是一次采购，含日期、供应商、配件、数量和金额。',
        ownerMemberId: 3855,
        ownerName: '袁宁松',
        visibility: 1,
        versionId: 'bidsv_01m53sz6qkmj12tzmxbwa3byhh',
        versionNo: 1,
        rowCount: 186,
        columnCount: 6,
        sourceFileName: '2025配件采购.xlsx',
        sourceSheet: '配件采购',
        createdAt: '2026-10-17T02:10:05.000Z',
        updatedAt: '2026-10-17T02:10:05.000Z',
        lastUsedAt: '2026-10-17T02:10:05.000Z',
        permission: 'manage',
        usage: {
          dashboardCount: 1,
          cardCount: 1,
        },
      },
    },
  ],
} as unknown as BiDatasetList;

export const kCapturedShared = {
  section: 'shared',
  datasets: [
    {
      kind: 'upload',
      dataset: {
        id: 'bids_01m53sz7af2mz2b69hsj52t80c',
        name: '客户回访记录',
        description: '客户回访记录。',
        ownerMemberId: 3856,
        ownerName: '钟三霞',
        visibility: 2,
        versionId: 'bidsv_01m53sz7afcsnd1q49p673t817',
        versionNo: 1,
        rowCount: 40,
        columnCount: 3,
        sourceFileName: null,
        sourceSheet: null,
        createdAt: '2026-10-17T02:10:05.000Z',
        updatedAt: '2026-10-17T02:10:05.000Z',
        lastUsedAt: null,
        permission: 'use',
        usage: {
          dashboardCount: 0,
          cardCount: 0,
        },
      },
    },
  ],
} as unknown as BiDatasetList;

export const kCapturedDetails = [
  {
    kind: 'upload',
    dataset: {
      id: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
      name: '2025 配件采购',
      description:
        '2025 年配件采购明细：每行是一次采购，含日期、供应商、配件、数量和金额。',
      ownerMemberId: 3855,
      ownerName: '袁宁松',
      visibility: 1,
      versionId: 'bidsv_01m53sz6qkmj12tzmxbwa3byhh',
      versionNo: 1,
      rowCount: 186,
      columnCount: 6,
      sourceFileName: '2025配件采购.xlsx',
      sourceSheet: '配件采购',
      createdAt: '2026-10-17T02:10:05.000Z',
      updatedAt: '2026-10-17T02:10:05.000Z',
      lastUsedAt: '2026-10-17T02:10:05.000Z',
      permission: 'manage',
      usage: {
        dashboardCount: 1,
        cardCount: 1,
      },
    },
    catalog: {
      dataset: {
        kind: 'upload',
        datasetId: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
      },
      label: {
        zh: '2025 配件采购',
        en: '2025 配件采购',
      },
      description: {
        zh: '2025 年配件采购明细：每行是一次采购，含日期、供应商、配件、数量和金额。',
        en: '2025 年配件采购明细：每行是一次采购，含日期、供应商、配件、数量和金额。',
      },
      primaryTime: 'f_purchase_date',
      fields: [
        {
          key: 'f_purchase_date',
          label: {
            zh: '采购日期',
            en: '采购日期',
          },
          role: 'dimension',
          type: 'date',
          grains: ['day', 'week', 'month', 'quarter', 'year'],
          conformedKey: 'date',
        },
        {
          key: 'f_supplier',
          label: {
            zh: '供应商',
            en: '供应商',
          },
          role: 'dimension',
          type: 'string',
        },
        {
          key: 'f_part_name',
          label: {
            zh: '配件名称',
            en: '配件名称',
          },
          role: 'dimension',
          type: 'string',
        },
        {
          key: 'f_license_plate',
          label: {
            zh: '车牌',
            en: '车牌',
          },
          role: 'dimension',
          type: 'string',
          conformedKey: 'license_plate',
        },
        {
          key: 'row_count',
          label: {
            zh: '行数',
            en: 'rows',
          },
          role: 'measure',
          type: 'number',
          aggs: [],
        },
        {
          key: 'f_quantity',
          label: {
            zh: '数量',
            en: '数量',
          },
          role: 'measure',
          type: 'number',
          aggs: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
          defaultAgg: 'sum',
        },
        {
          key: 'f_amount',
          label: {
            zh: '金额',
            en: '金额',
          },
          role: 'measure',
          type: 'number',
          aggs: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
          defaultAgg: 'sum',
        },
      ],
    },
    usageDetail: {
      dashboards: [
        {
          dashboardId: 'bidash_01m53sz7j6gsbwn9w8jbkv0g7y',
          name: '采购分析',
          cardCount: 1,
        },
      ],
      hiddenDashboardCount: 0,
      cardCount: 1,
    },
  },
  {
    kind: 'upload',
    dataset: {
      id: 'bids_01m53sz7af2mz2b69hsj52t80c',
      name: '客户回访记录',
      description: '客户回访记录。',
      ownerMemberId: 3856,
      ownerName: '钟三霞',
      visibility: 2,
      versionId: 'bidsv_01m53sz7afcsnd1q49p673t817',
      versionNo: 1,
      rowCount: 40,
      columnCount: 3,
      sourceFileName: null,
      sourceSheet: null,
      createdAt: '2026-10-17T02:10:05.000Z',
      updatedAt: '2026-10-17T02:10:05.000Z',
      lastUsedAt: null,
      permission: 'use',
      usage: {
        dashboardCount: 0,
        cardCount: 0,
      },
    },
    catalog: {
      dataset: {
        kind: 'upload',
        datasetId: 'bids_01m53sz7af2mz2b69hsj52t80c',
      },
      label: {
        zh: '客户回访记录',
        en: '客户回访记录',
      },
      description: {
        zh: '客户回访记录。',
        en: '客户回访记录。',
      },
      primaryTime: 'f_day',
      fields: [
        {
          key: 'f_day',
          label: {
            zh: '回访日期',
            en: '回访日期',
          },
          role: 'dimension',
          type: 'date',
          grains: ['day', 'week', 'month', 'quarter', 'year'],
        },
        {
          key: 'f_result',
          label: {
            zh: '回访结果',
            en: '回访结果',
          },
          role: 'dimension',
          type: 'string',
        },
        {
          key: 'row_count',
          label: {
            zh: '行数',
            en: 'rows',
          },
          role: 'measure',
          type: 'number',
          aggs: [],
        },
        {
          key: 'f_score',
          label: {
            zh: '满意度',
            en: '满意度',
          },
          role: 'measure',
          type: 'number',
          aggs: ['sum', 'avg', 'min', 'max', 'count', 'count_distinct'],
          defaultAgg: 'avg',
        },
      ],
    },
    usageDetail: {
      dashboards: [],
      hiddenDashboardCount: 0,
      cardCount: 0,
    },
  },
] as unknown as BiDatasetDetail[];

export const kCapturedSharedPreview = {
  columns: [
    {
      key: 'f_day',
      label: {
        zh: '回访日期',
        en: '回访日期',
      },
      type: 'date',
      role: 'dimension',
    },
    {
      key: 'f_result',
      label: {
        zh: '回访结果',
        en: '回访结果',
      },
      type: 'string',
      role: 'dimension',
    },
    {
      key: 'f_score',
      label: {
        zh: '满意度',
        en: '满意度',
      },
      type: 'number',
      role: 'measure',
    },
  ],
  rows: [
    ['2025-01-10', '满意', 3],
    ['2025-02-11', '一般', 4],
    ['2025-03-12', '不满意', 5],
    ['2025-04-13', '满意', 3],
    ['2025-05-14', '一般', 4],
    ['2025-06-15', '不满意', 5],
    ['2025-07-16', '满意', 3],
    ['2025-08-17', '一般', 4],
    ['2025-09-18', '不满意', 5],
    ['2025-01-10', '满意', 3],
    ['2025-02-11', '一般', 4],
    ['2025-03-12', '不满意', 5],
    ['2025-04-13', '满意', 3],
    ['2025-05-14', '一般', 4],
    ['2025-06-15', '不满意', 5],
    ['2025-07-16', '满意', 3],
    ['2025-08-17', '一般', 4],
    ['2025-09-18', '不满意', 5],
    ['2025-01-10', '满意', 3],
    ['2025-02-11', '一般', 4],
    ['2025-03-12', '不满意', 5],
    ['2025-04-13', '满意', 3],
    ['2025-05-14', '一般', 4],
    ['2025-06-15', '不满意', 5],
    ['2025-07-16', '满意', 3],
    ['2025-08-17', '一般', 4],
    ['2025-09-18', '不满意', 5],
    ['2025-01-10', '满意', 3],
    ['2025-02-11', '一般', 4],
    ['2025-03-12', '不满意', 5],
    ['2025-04-13', '满意', 3],
    ['2025-05-14', '一般', 4],
    ['2025-06-15', '不满意', 5],
    ['2025-07-16', '满意', 3],
    ['2025-08-17', '一般', 4],
    ['2025-09-18', '不满意', 5],
    ['2025-01-10', '满意', 3],
    ['2025-02-11', '一般', 4],
    ['2025-03-12', '不满意', 5],
    ['2025-04-13', '满意', 3],
  ],
  truncated: false,
  asOf: '2026-10-17T02:10:05.714Z',
} as unknown as BiDatasetPreview;

export const kCapturedPreview = {
  columns: [
    {
      key: 'f_purchase_date',
      label: {
        zh: '采购日期',
        en: '采购日期',
      },
      type: 'date',
      role: 'dimension',
    },
    {
      key: 'f_supplier',
      label: {
        zh: '供应商',
        en: '供应商',
      },
      type: 'string',
      role: 'dimension',
    },
    {
      key: 'f_part_name',
      label: {
        zh: '配件名称',
        en: '配件名称',
      },
      type: 'string',
      role: 'dimension',
    },
    {
      key: 'f_quantity',
      label: {
        zh: '数量',
        en: '数量',
      },
      type: 'number',
      role: 'measure',
    },
    {
      key: 'f_amount',
      label: {
        zh: '金额',
        en: '金额',
      },
      type: 'number',
      role: 'measure',
    },
    {
      key: 'f_license_plate',
      label: {
        zh: '车牌',
        en: '车牌',
      },
      type: 'string',
      role: 'dimension',
    },
  ],
  rows: [
    ['2025-01-01', '博世配件', '机油滤芯', 1, 80, '川A10000'],
    ['2025-02-02', '马牌轮胎', '刹车片', 2, 117, '川A10131'],
    ['2025-03-03', '嘉实多', '轮胎', 3, 154, '川A10262'],
    ['2025-04-04', '曼牌滤清器', '机油', 4, 191, '川A10393'],
    ['2025-05-05', '法雷奥', '火花塞', 5, 228, '川A10524'],
    ['2025-06-06', '博世配件', '雨刮', 6, 265, '川A10655'],
    ['2025-07-07', '马牌轮胎', '机油滤芯', 7, 302, '川A10786'],
    ['2025-08-08', '嘉实多', '刹车片', 8, 339, '川A10917'],
    ['2025-09-09', '曼牌滤清器', '轮胎', 9, 376, '川A11048'],
    ['2025-10-10', '法雷奥', '机油', 1, 413, '川A11179'],
    ['2025-11-11', '博世配件', '火花塞', 2, 450, '川A11310'],
    ['2025-12-12', '马牌轮胎', '雨刮', 3, 487, '川A11441'],
    ['2025-01-13', '嘉实多', '机油滤芯', 4, 524, '川A11572'],
    ['2025-02-14', '曼牌滤清器', '刹车片', 5, 561, '川A11703'],
    ['2025-03-15', '法雷奥', '轮胎', 6, 598, '川A11834'],
    ['2025-04-16', '博世配件', '机油', 7, 635, '川A11965'],
    ['2025-05-17', '马牌轮胎', '火花塞', 8, 672, '川A12096'],
    ['2025-06-18', '嘉实多', '雨刮', 9, 709, '川A12227'],
    ['2025-07-19', '曼牌滤清器', '机油滤芯', 1, 746, '川A12358'],
    ['2025-08-20', '法雷奥', '刹车片', 2, 783, '川A12489'],
    ['2025-09-21', '博世配件', '轮胎', 3, 820, '川A12620'],
    ['2025-10-22', '马牌轮胎', '机油', 4, 857, '川A12751'],
    ['2025-11-23', '嘉实多', '火花塞', 5, 894, '川A12882'],
    ['2025-12-24', '曼牌滤清器', '雨刮', 6, 931, '川A13013'],
    ['2025-01-25', '法雷奥', '机油滤芯', 7, 968, '川A13144'],
    ['2025-02-26', '博世配件', '刹车片', 8, 105, '川A13275'],
    ['2025-03-27', '马牌轮胎', '轮胎', 9, 142, '川A13406'],
    ['2025-04-01', '嘉实多', '机油', 1, 179, '川A13537'],
    ['2025-05-02', '曼牌滤清器', '火花塞', 2, 216, '川A13668'],
    ['2025-06-03', '法雷奥', '雨刮', 3, 253, '川A13799'],
    ['2025-07-04', '博世配件', '机油滤芯', 4, 290, '川A13930'],
    ['2025-08-05', '马牌轮胎', '刹车片', 5, 327, '川A14061'],
    ['2025-09-06', '嘉实多', '轮胎', 6, 364, '川A14192'],
    ['2025-10-07', '曼牌滤清器', '机油', 7, 401, '川A14323'],
    ['2025-11-08', '法雷奥', '火花塞', 8, 438, '川A14454'],
    ['2025-12-09', '博世配件', '雨刮', 9, 475, '川A14585'],
    ['2025-01-10', '马牌轮胎', '机油滤芯', 1, 512, '川A14716'],
    ['2025-02-11', '嘉实多', '刹车片', 2, 549, '川A14847'],
    ['2025-03-12', '曼牌滤清器', '轮胎', 3, 586, '川A14978'],
    ['2025-04-13', '法雷奥', '机油', 4, 623, '川A15109'],
    ['2025-05-14', '博世配件', '火花塞', 5, 660, '川A15240'],
    ['2025-06-15', '马牌轮胎', '雨刮', 6, 697, '川A15371'],
    ['2025-07-16', '嘉实多', '机油滤芯', 7, 734, '川A15502'],
    ['2025-08-17', '曼牌滤清器', '刹车片', 8, 771, '川A15633'],
    ['2025-09-18', '法雷奥', '轮胎', 9, 808, '川A15764'],
    ['2025-10-19', '博世配件', '机油', 1, 845, '川A15895'],
    ['2025-11-20', '马牌轮胎', '火花塞', 2, 882, '川A16026'],
    ['2025-12-21', '嘉实多', '雨刮', 3, 919, '川A16157'],
    ['2025-01-22', '曼牌滤清器', '机油滤芯', 4, 956, '川A16288'],
    ['2025-02-23', '法雷奥', '刹车片', 5, 93, '川A16419'],
  ],
  truncated: true,
  asOf: '2026-10-17T02:10:05.686Z',
} as unknown as BiDatasetPreview;

/** Switching the private dataset to the store, unconfirmed. */
export const kCapturedVisibilityPreview = {
  applied: false,
  widens: true,
  audience: {
    everyone: true,
    members: [],
  },
  dataset: {
    id: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
    name: '2025 配件采购',
    description:
      '2025 年配件采购明细：每行是一次采购，含日期、供应商、配件、数量和金额。',
    ownerMemberId: 3855,
    ownerName: '袁宁松',
    visibility: 1,
    versionId: 'bidsv_01m53sz6qkmj12tzmxbwa3byhh',
    versionNo: 1,
    rowCount: 186,
    columnCount: 6,
    sourceFileName: '2025配件采购.xlsx',
    sourceSheet: '配件采购',
    createdAt: '2026-10-17T02:10:05.000Z',
    updatedAt: '2026-10-17T02:10:05.000Z',
    lastUsedAt: '2026-10-17T02:10:05.000Z',
    permission: 'manage',
    usage: {
      dashboardCount: 1,
      cardCount: 1,
    },
  },
  grants: [],
} as unknown as BiDatasetSharingResult;

/** Granting a colleague use, unconfirmed. */
export const kCapturedGrantsPreview = {
  applied: false,
  widens: true,
  audience: {
    everyone: false,
    members: [
      {
        memberId: 3855,
        name: '袁宁松',
      },
      {
        memberId: 3857,
        name: '何君',
      },
    ],
  },
  dataset: {
    id: 'bids_01m53sz6qkde2w91fdrt0ycpk7',
    name: '2025 配件采购',
    description:
      '2025 年配件采购明细：每行是一次采购，含日期、供应商、配件、数量和金额。',
    ownerMemberId: 3855,
    ownerName: '袁宁松',
    visibility: 1,
    versionId: 'bidsv_01m53sz6qkmj12tzmxbwa3byhh',
    versionNo: 1,
    rowCount: 186,
    columnCount: 6,
    sourceFileName: '2025配件采购.xlsx',
    sourceSheet: '配件采购',
    createdAt: '2026-10-17T02:10:05.000Z',
    updatedAt: '2026-10-17T02:10:05.000Z',
    lastUsedAt: '2026-10-17T02:10:05.000Z',
    permission: 'manage',
    usage: {
      dashboardCount: 1,
      cardCount: 1,
    },
  },
  grants: [],
} as unknown as BiDatasetSharingResult;

/** Deleting the used dataset: refused (`bi_dataset_in_use`), its i18n params. */
export const kCapturedDeleteRefusal = {
  code: 'resource_state_conflict',
  subCode: 'bi_dataset_in_use',
  i18n: {
    count: 1,
    dashboards: '采购分析',
  },
};
